// import { getCarouselTemplate } from "@/lobby_common/api/basic_gen";
import { getCarouselTemplateC as getCarouselTemplate } from "@/lobby_common/api/cacheApi";
import { debounce } from "@/lobby_common/utils/index.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { mapGetters } from "vuex";
// import { getAnyZoneTime1 } from "@/lobby_common/utils/date.js";
export default {
  props: {
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bannerH5: 175,
      bannerPC: 260,
      pcType: {
        pu: "pc_image_url_pu",
        en: "pc_image_url_en",
        tw: "pc_image_url_tw",
      },
      h5Type: {
        pu: "h5_image_url_pu",
        en: "h5_image_url_en",
        tw: "h5_image_url_tw",
      },
      value: 0,
      slides: [],
      timer: null,
      currentIndx: 0,
      options: {
        autoplay: 4500, // 自动滚动[ms]
        effect: "fade",
        loop: true,
        speed: 500,
        currentPage: 0, // 当前
      },
      currentIndex: 0,
    };
  },
  computed: {
    indicatorsTransform() {
      if (this.currentIndex < 2) return "transform: translateY(0)";

      let offset = 0;

      if (this.listFormat.length - this.currentIndex > 1) {
        offset = 1;
      }

      return `transform: translateY(-${
        (this.currentIndex - 3 + 1 + offset) * (this.bannerPC / 3 + 10)
      }px)`;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      const num = 375 / 750;
      const imgWidth = (containerWidth - 20) / 3;
      return imgWidth * num;
    },
    list() {
      return this.slides;
    },
    listPc() {
      const newArr = [];
      const num = 3;
      // 轮播图长度 <= 3
      if (this.slides.length <= num) return [this.slides];
      // 轮播图长度 > 3
      for (let i = 0; i < this.slides.length; ) {
        if (i + num >= this.slides.length) {
          newArr.push(
            this.slides.slice(this.slides.length - 3, this.slides.length)
          );
          i += num;
        } else {
          newArr.push(this.slides.slice(i, (i += num)));
        }
        // newArr.push(this.slides.slice(i, i += num));
      }
      // console.log(newArr, 'newArrnewArrnewArr')
      return newArr;
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    // 默认
    // ROTATION_TEMPLATE_STYLE_ALL = 0;
    // // 平铺1
    // ROTATION_TEMPLATE_STYLE_TILE_ONE = 1;
    // // 平铺2
    // ROTATION_TEMPLATE_STYLE_TILE_TWO = 2;
    // // 大图——缩略图
    // ROTATION_TEMPLATE_STYLE_BIG_IMAGE = 3;
    // // 过度
    // ROTATION_TEMPLATE_STYLE_TRANSITION = 4;
    // // 平铺1.5
    // ROTATION_TEMPLATE_STYLE_TILE_THREE = 5;
    // // 平铺3
    // ROTATION_TEMPLATE_STYLE_TILE_FOUR = 6;
    isNomal() {
      return this.list.length && !this.list[0]?.rotationTemplateStyle;
    },
    // 平铺1
    tiliOne() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_TILE_ONE"
      );
    },
    // 平铺2
    tiliTwo() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_TILE_TWO"
      );
    },
    // 平铺1.5
    isCard() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_TILE_THREE"
      );
    },
    // 透明渐变过渡
    gradient() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_TILE_SEVEN"
      );
    },
    // 透明渐变过渡-h5
    gradientH5() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyleH5 ===
          "ROTATION_TEMPLATE_STYLE_TILE_SEVEN"
      );
    },
    // 平铺3
    tiliOneThree() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_TILE_FOUR"
      );
    },
    // 大图——缩略图
    thumbnail() {
      return (
        this.list.length &&
        this.list[0].rotationTemplateStyle ===
          "ROTATION_TEMPLATE_STYLE_BIG_IMAGE"
      );
    },
    rotationTime() {
      let time = this.list.length && this.list[0].rotationTime * 1000;
      if (isNaN(time) || time < 1) {
        time = 3000;
      }
      return time;
    },
    showIndicator() {
      return (
        this.list.length &&
        this.list[0].rotationImageTemplateStyle === "ROTATION_STYLE_TILE_ONE"
      );
    },
    showArrow() {
      return (
        this.list.length &&
        this.list[0].rotationImageTemplateStyle === "ROTATION_STYLE_TILE_TWO"
      );
    },
    showProgress() {
      return (
        this.list.length &&
        this.list[0].rotationImageTemplateStyle === "ROTATION_STYLE_TILE_THREE"
      );
    },
    listFormat() {
      if (this.tiliOne || this.isCard || this.gradient) return this.slides;
      if (this.tiliTwo) return this.convertToGroups(this.slides, 2);
      if (this.tiliOneThree) return this.convertToGroups(this.slides, 3);
      return this.slides;
    },
    ...mapGetters(["getIsMobile", "menuIsShow"]),
    // isMobile() {
    //   return this.$store.getIsMobile;
    // },
  },
  watch: {
    menuIsShow: {
      handler: function () {
        const timer = setTimeout(() => {
          this.imgLoad();
          clearTimeout(timer);
        }, 500);
      },
      deep: true,
      // immediate: true,
    },
  },
  created() {
    this.marqueeListFun();
  },
  activated() {
    this.imgLoad();
  },
  mounted() {
    console.log(this.item, "item");
    if (this.isMobile()) {
      this.slideBanner();
      // this.getTime();
    }
    this.resizeHandler = debounce(() => {
      this.imgLoad();
    }, 600);
    this.resizeHandler();
    window.addEventListener("resize", this.imgLoad, false);
    const timer = setTimeout(() => {
      this.imgLoad();
      clearTimeout(timer);
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.imgLoad);
  },
  // activated() {
  //   this.imgLoad();
  // },
  methods: {
    /**
     * 将一维图像数组转换为每组包含指定数量图像的二维数组。
     *
     * @param {Array} images - 一维图像数组。
     * @param {number} groupSize - 每组包含的图像数量。
     * @returns {Array} - 二维图像数组。
     */
    convertToGroups(images, groupSize) {
      const result = [];
      for (let i = 0; i < images.length; i += groupSize) {
        result.push(images.slice(i, i + groupSize));
      }
      return result;
    },
    onChange(current, prev) {
      this.currentIndex = current;
    },
    setActive(index) {
      this.currentIndex = index;
      this.$refs.slideCarouselPcVertical.setActiveItem(index); // 通过调用 carousel 组件实例的方法来设置活动的幻灯片
    },
    imgLoad() {
      // console.log(this.slides , 'this.slides')
      if (this.slides.length > 0) {
        this.$nextTick(() => {
          const ref = this.$refs;
          this.bannerH5 =
            ref.bannerH5 && ref.bannerH5.length ? ref.bannerH5[0].height : "";
          this.bannerPC =
            ref.bannerPC && ref.bannerPC.length ? ref.bannerPC[0].height : "";
          console.log(this.bannerPC, "  this.bannerPC ");
          // console.log('ref.bannerPC=>>>', ref.bannerPC)
          // this.bannerPC = this.getImgHeight;
        });
      }
    },
    isMobile() {
      // match方法可在字符串内检索指定的值，
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    bGimg(opt) {
      // const styles = {
      //   "background-image": "url(" + opt[this.pcType[this.$i18n.locale]] + ")",
      // };
      return opt[this.pcType[this.$i18n.locale]];
    },
    h5bGimg(opt) {
      // const styles = {
      //   "background-image": "url(" + opt[this.h5Type[this.$i18n.locale]] + ")",
      // };
      const url = opt[this.h5Type[this.$i18n.locale]];
      return url;
    },
    async marqueeListFun() {
      const { code, data } = await getCarouselTemplate({});
      // console.log(data, "------marqueeListFun--------");
      if (code === 0) {
        // this.slides = data?.list || [];
        const list = data?.list || [];
        this.slides = list.map((item, i) => {
          return {
            ...item,
            eid: `101_11_${this.curindex}_${i}`,
          };
        });
        // console.log("slides", this.slides);
        if (this.slides.length) {
          this.imgLoad();
        }
      }
    },
    btnCilck(data, index) {
      console.log(data, "1111");
      const item = data || {};
      this.$eventPost("rotation_chart", {
        chartId: item.sid,
        enum: item.jump?.functionType || "",
        jump_value: data.jump,
        eid: item.eid,
        SubCarouselLocation: index,
      });
      this.$eventPost("click", {
        eid: item.eid,
        time: Date.now(),
        chartId: item.sid,
        enum: item.jump?.functionType || "",
        jump_value: data.jump,
      });
      goJoinEvent(item.jump);
    },
    getImgUrl(item, type) {
      const obj = item.language || {};
      // console.log('obj', item, obj);
      return obj[type];
    },
    slideBanner() {
      // 选中的轮播图
      var box = document.querySelector(".mobileBox");
      if (box !== null) {
        var startPoint = 0;
        var stopPoint = 0;
        // 重置坐标
        var resetPoint = function () {
          startPoint = 0;
          stopPoint = 0;
        };
        // 手指按下
        box.addEventListener("touchstart", function (e) {
          // 手指点击位置的X坐标
          startPoint = e.changedTouches[0].pageX;
        });
        // 手指滑动
        box.addEventListener("touchmove", function (e) {
          // 手指滑动后终点位置X的坐标
          stopPoint = e.changedTouches[0].pageX;
        });
        // 当手指抬起的时候，判断图片滚动离左右的距离
        const that = this;
        box.addEventListener("touchend", function (e) {
          // console.log("1：" + startPoint);
          // console.log("2：" + stopPoint);
          if (stopPoint === 0 || startPoint - stopPoint === 0) {
            resetPoint();
            return;
          }
          if (startPoint - stopPoint > 0) {
            resetPoint();
            that.$refs.slideCarousel.next();
            return;
          }
          if (startPoint - stopPoint < 0) {
            resetPoint();
            that.$refs.slideCarousel.prev();
            return;
          }
        });
      }
    },
    // pc 上一张幻灯片
    turnLeft() {
      this.$refs.slideCarouselPc.prev();
    },
    // pc 下一张幻灯片
    turnRight() {
      this.$refs.slideCarouselPc.next();
    },

    slide(data) {
      // console.log(data);
      this.currentIndx = data.currentPage;
    },
    onTap(data) {
      // console.log(data);
    },
    onInit(data) {
      // console.log(data);
    },
  },
};
